import "./Events.module.css";
import Header from "@/reusable_sections/Header";
import Events from "./sections/Events";
import EventDjAndReservations from "./sections/EventDjAndReservations";
import EventGallery from "./sections/EventGallery";
import RezervirajteSubitie from "./sections/RezervirajteSubitie";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function EventsPage() {
  return <div>
      <Header />
      <Events />
      <EventDjAndReservations />
      <EventGallery />
      <RezervirajteSubitie />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}